// format YYYY-mm-DD
// Commented AGE57 for now; it will be enabled in the future if required.
// const apr_06_1973 = new Date("1973-04-06");

const minAge50 = 50,
  minAge55 = 55,
  // Commented AGE57 for now; it will be enabled in the future if required.
  // minAge57 = 57,
  maxAge75 = 75;

export const getApplicableMinMaxTra = (dob, doj, schemeData) => {
  var traObj = {
    min: minAge55,
    max: maxAge75,
    ppa: schemeData?.ppa,
  };

  // Commented AGE57 for now; it will be enabled in the future if required.
  // const _dob = new Date(dob);

  if (traObj.ppa === "Y") {
    traObj.min = minAge50;
    // Commented AGE57 for now; it will be enabled in the future if required.
    // } else if (_dob >= apr_06_1973) {
    //   traObj.min = minAge57;
  } else {
    traObj.min = minAge55;
  }
  return traObj;
};

export function getAge(dob) {
  const today = new Date();
  var birthDate = new Date(dob);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function getActiveEmployerObj(accountObj) {
  return accountObj?.employmentList?.find((employment) => {
    return employment.isRecentActive;
  });
}

export function checkIfSameTraInAllPots(accountDetailsForSavings) {
  // Checking if all pot account has the same age
  let ageArr = [];
  if (accountDetailsForSavings?.length > 1) {
    accountDetailsForSavings?.forEach((potItem) => {
      ageArr.push(potItem.retirementAge);
    });
  }
  const ageSet = new Set(ageArr);
  return !(ageSet.size > 1);
}
